import Tooltip from '@mindtickle/tooltip';

import { getPopupContainerOnBody } from '@mindtickle/utils';

import ButtonWithIcon from '@mindtickle/button/lib/ButtonWithIcon';
import Divider from '@mindtickle/divider';
import { ICON_MAP } from '@mindtickle/icon';
import Label from '@mindtickle/label';
import { TEXT_COLORS, TEXT_TYPES, TEXT_MODIFIERS } from '@mindtickle/styles/lib/classNames';
import { withTracking } from '@mindtickle/ui-shell-core/Mixpanel';

import AdvanceLink from '~/components/GlobalHeader/Admin/components/AdvanceLink';
import { MixpanelTrackType, MixpanelEventNameType } from '~/components/GlobalHeader/Admin/type';
import messages from '../../messages';
import useCopyData from './hooks/useCopyData';
import { StyledDropdownActionItemWrapper, StyledLearningWrapper } from './style';
import { IntlType } from '~/components/GlobalHeader/Shared/type';

type LearningSiteProps = {
  eventName: MixpanelEventNameType;
  track: MixpanelTrackType<MixpanelEventNameType>;
  url: string;
  onHideDropdownContent: Function;
  intl: IntlType;
};

const LearningSiteAction = ({
  eventName,
  track,
  url,
  onHideDropdownContent,
  intl,
}: LearningSiteProps) => {
  const { onCopyHandler, isCopied } = useCopyData(url);

  const handleLearningSiteClick = () => {
    onHideDropdownContent();
    track(eventName);
  };

  return (
    <StyledLearningWrapper>
      <AdvanceLink url={url} className="advance-link">
        <StyledDropdownActionItemWrapper
          className="dropdown-action-item-wrapper"
          data-testid={'ls-btn'}
          onClick={handleLearningSiteClick}
        >
          <Label
            tag="div"
            type={TEXT_TYPES.BODY_MEDIUM_DEFAULT}
            color={TEXT_COLORS.TERTIARY}
            message={messages.VIEW_AS_LEARNER}
            className="dropdown-action-label"
            modifier={TEXT_MODIFIERS.TYPOGRAPHY_MOD_STRONG}
          />
        </StyledDropdownActionItemWrapper>
      </AdvanceLink>
      <Divider type="vertical" className="learning-site-divider" />
      <Tooltip
        getPopupContainer={getPopupContainerOnBody}
        placement="bottomRight"
        title={intl.formatMessage(isCopied ? messages.COPIED : messages.COPY_URL)}
      >
        <ButtonWithIcon
          className="learning-site-copy-btn"
          iconType={ICON_MAP.EMBED}
          onClick={onCopyHandler}
        />
      </Tooltip>
    </StyledLearningWrapper>
  );
};
export default withTracking()(LearningSiteAction);
